export const PAYMENT_INTEGRATIONS_EVENTS = {
    VIEW_PAYMENT_INTAGRATIONS_PAGE: 'view_payment_integrations_page',
    CREATE_PAYMENT_INTAGRATIONS: 'create_payment_integration'
}

export const PAYMENT_INTEGRATIONS_EVENTS_PARAMS = {
    PAYMENT_INTEGRATIONS: 'payment_integration',
    EVENTS_SUBSCRIBED_COUNT: 'events_subscribed_count'
}